import { notify } from '../../shared';

import { useConfirm, useRequest } from '../../hooks';
import { wipeContact, startCampaignForContact } from '../../api';
import type { ContactItemType } from '../../templates';

const DELAY = 2 * 1_000;
const startCampaignForContactWithDelay = async (
  ...params: Parameters<typeof startCampaignForContact>
) => {
  const result = await startCampaignForContact(...params);
  await new Promise(resolve => setTimeout(resolve, DELAY));

  return result;
};

export const useContactActions = (onRefresh: () => void) => {
  const { element: startElement, open: handleOpenStart } = useConfirm();
  const [handleStartCampaign, starting] = useRequest(
    (_signal, item: ContactItemType) =>
      startCampaignForContactWithDelay({
        campaign_strategy: 'default',
        contact_id: item.id,
        user_email: item.email,
      }),
    {
      deps: [],
      onSuccess: data => {
        notify.success(data?.message || 'Campaign Started');
        onRefresh();
      },
      onError: () => {
        notify.error('Failed to start Campaign');
      },
    }
  );
  const { element: wipeElement, open: handleOpenWipe } = useConfirm();
  const [handleWipeContact, wiping] = useRequest(
    (_signal, item: ContactItemType) => wipeContact(item.id),
    {
      deps: [],
      onSuccess: data => {
        notify.success(data?.message || 'Contact data was cleaned');
        onRefresh();
      },
      onError: () => {
        notify.error('Failed to crean Contact data');
      },
    }
  );

  return {
    progress: starting || wiping,

    startElement,
    openStart: (item: ContactItemType) => {
      return handleOpenStart({
        text: `Are you sure you want to start a campaign for ${item.email}?`,
        onConfirm: () => handleStartCampaign(item),
      });
    },

    wipeElement,
    openWipe: (item: ContactItemType) => {
      return handleOpenWipe({
        title: 'Clean Contact Data',
        text: `This action deletes ALL data (tasks, messages, events, states) for ${item.email} but keeps the contact. Are you sure?`,
        onConfirm: () => handleWipeContact(item),
      });
    },
  };
};
